
import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import GeneralReducer from "./GeneralReducer";
import PagesReducer from "./PagesReducer";
import AssetsReducer from "./AssetsReducer";
import ScheduleReducer from "./ScheduleReducer";
import ChatReducer from "./ChatReducer";
import CusAssetsReducer from "./CusAssetsReducer";
import CusModulesReducer from "./CusModulesReducer";
import CompanyReducer from "./CompanyReducer";
//Customer

// const eventPlanPersistConfig = {
//   key: "root",
//   storage: storage,
//   whitelist: [
//     "EventPlanningReducer",
//     "GuestReducer",
//     "EventReducer",
//     "AuthReducer",
//   ],
// };

const AppReducers = combineReducers({
  GeneralReducer,
  AuthReducer,
  PagesReducer,
  AssetsReducer,
  ScheduleReducer,
  ChatReducer,
  //Customer
  CusAssetsReducer,
  CusModulesReducer,
  CompanyReducer,
});

const Reducer = (state, action) => {
  if (action.type === "IsLogout") {
    return AppReducers(undefined, action);
  }
  return AppReducers(state, action);
};
// const persistedReducer = persistReducer(eventPlanPersistConfig, Reducer);

export default Reducer;
